import React from 'react';

const Magnifier = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M20.3288 21.7429C18.6049 23.1536 16.4013 24 14 24C8.47715 24 4 19.5228 4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14C24 16.4012 23.1537 18.6048 21.743 20.3287L27.5313 26.117C27.9218 26.5075 27.9218 27.1407 27.5313 27.5312C27.1408 27.9217 26.5076 27.9217 26.1171 27.5312L20.3288 21.7429ZM22 14C22 9.58172 18.4183 6 14 6C9.58172 6 6 9.58172 6 14C6 18.4183 9.58172 22 14 22C18.4183 22 22 18.4183 22 14Z" />
  </svg>
);

export default Magnifier;
